const wowApp = require('angular').module('wowApp.shop');
wowApp.directive('wowStarRating', [require('./star-rating-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/star-rating/index.js
 **/